<template>
    <div>
        <img v-if="!isMyBeauty" alt="Rewards Card" src="@/assets/Rewards-Card-Visual.png" />
        <img v-if="isMyBeauty" alt="Rewards Card" src="@/assets/Rewards-Card-Visual_MyBeauty.png" />
    </div>
</template>

<script setup>
    import { inject, computed } from 'vue'
    import { useRoute } from 'vue-router'
    const route = useRoute()

    // Use inject if isMyBeauty is provided globally
    const isMyBeauty = inject('isMyBeauty', computed(() =>
        route.params.isMyBeauty === 'mybeauty' ||
        route.query.isMyBeauty === 'true' ||
        route.query.isMyBeauty === true
    ))
</script>

<style lang="scss" scoped>
</style>